import { FilesGateway } from './files-gateway.interface';

export const initFilesAPI = (apiSlice: any, gateway: FilesGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Document'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getDocumentBlobById: builder.mutation({
          query: gateway.getDocumentBlobById,
        }),
        download: builder.mutation({
          query: gateway.download,
        }),
        getDocumentBlobByProjectAndSlug: builder.mutation({
          query: gateway.getDocumentBlobByProjectAndSlug,
        }),
        downloadDocumentBySlug: builder.mutation({
          query: gateway.downloadDocumentBySlug,
        }),
        getThumbnail: builder.mutation({
          query: gateway.getThumbnail,
        }),
        generateFile: builder.mutation({
          query: gateway.generateFile,
          invalidatesTags: ['Document'],
        }),
        getTempAmendementFile: builder.mutation({
          query: gateway.getTempAmendementFile,
        }),
        generateQuoteDocumentAndGetFile: builder.mutation({
          query: gateway.generateQuoteDocumentAndGetFile,
        }),
        getQuoteFileFromMainConfig: builder.mutation({
          query: gateway.getQuoteFileFromMainConfig,
        }),
        downloadIfc: builder.mutation({
          query: gateway.downloadIfc,
        }),
      }),
      overrideExisting: false,
    });
};

export interface FilesSliceType {
  useGetDocumentBlobByIdMutation: Function;
  useDownloadMutation: Function;
  useGetDocumentBlobByProjectAndSlugMutation: Function;
  useDownloadDocumentBySlugMutation: Function;
  useGetThumbnailMutation: Function;
  useGenerateFileMutation: Function;
  useGetTempAmendementFileMutation: Function;
  useGenerateQuoteDocumentAndGetFileMutation: Function;
  useGetQuoteFileFromMainConfigMutation: Function;
  useLazyGetQuoteFileFromMainConfigMutation: Function;
  useDownloadIfcMutation: Function;
}
